/** @format */

import {Trans} from 'react-i18next';

import {ROUTES} from 'constants/ROUTES';
import Breadcrumbs from 'components/Breadcrumbs';

import {providerNewIconSrc} from 'helpers/imageHelpers';

interface YaDirectBreadcrumbsProps {
  companyName?: string;
}

const YaDirectBreadcrumbs = ({companyName}: YaDirectBreadcrumbsProps) => {
  const breadcrumbs = [
    {
      href: ROUTES.INDEX,
      title: <Trans>Проекты</Trans>,
    },
    {
      href: `/${ROUTES.HOME}`,
      title: companyName,
    },
    {
      href: `/${ROUTES.YA_DIRECT_CHANGE_LOG}`,
      title: (
        <>
          <Trans>История изменений Яндекс Директ</Trans>{' '}
          <img
            alt='Yandex Direct'
            style={{height: '1em', verticalAlign: 'middle'}}
            src={providerNewIconSrc('YANDEX', 20)}
          />
        </>
      ),
    },
  ];

  return <Breadcrumbs items={breadcrumbs} />;
};

export default YaDirectBreadcrumbs;
